module.exports = __webpack_public_path__ + "static/img/a039.a8853e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a039.jpg
// module id = TP8S
// module chunks = 0